import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useDreamSummary from '../hooks/useDreamSummary';
import { markDreamWinSeen, unseenDreamWin } from '../utils/dreamBoost';
import '../styles/DreamBoost.css';

// A fan who just won a Dream Prize or bonus drop sees it once, on their next
// open, the way the embed's dreamWin.js shows it. Keyed per prize in
// localStorage so a win is never announced twice.
function DreamWinAlert() {
  const navigate = useNavigate();
  const summary = useDreamSummary();
  const [win, setWin] = useState(null);

  useEffect(() => {
    if (!summary || !summary.enabled) return;
    const next = unseenDreamWin(summary.recent_winners);
    if (!next) return;
    markDreamWinSeen(next.prize_id);
    setWin(next);
  }, [summary]);

  if (!win) return null;
  const kind = win.draw_kind === 'bonus_drop' ? 'Bonus drop' : 'Dream Prize';
  const close = () => setWin(null);
  return (
    <div className="dream-win" role="presentation" onClick={close}>
      <div
        className="dream-win-sheet"
        role="dialog"
        aria-modal="true"
        aria-label="You won"
        onClick={(event) => event.stopPropagation()}
      >
        <span className="dream-win-mark" aria-hidden="true">
          🎉
        </span>
        <h2 className="dream-win-title">You won!</h2>
        <p className="dream-win-copy">
          {kind}
          {win.title ? `. ${win.title}.` : ''} Your entries came through. The team will reach out about
          collecting your prize.
        </p>
        <div className="dream-win-actions">
          {summary.period ? (
            <button
              type="button"
              className="dream-btn"
              onClick={() => {
                close();
                navigate('/dream');
              }}
            >
              See details
            </button>
          ) : null}
          <button type="button" className="dream-win-close" onClick={close}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default DreamWinAlert;
